import { ComponentConsumerProps, RichText } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import fields from '../../../../../constants/fields.const';
import { iconSize } from '../../../../../constants/icon.constants';
import { CustomText } from '../../../../@shared/customText';
import { FieldEditFrameComponent } from '../../../../@shared/editFrame';
import Icon from '../../../../@shared/icon';
import RoutableNotEditableLink from '../../../../@shared/routableNotEditableLink';
import CardColumnButtons from '../cardButtons';
import { TIconCardProps } from '../../../types/cardColumnLayout.types';
import { googleHomeServicesClickEvent } from '../../../../../utils/analytics';
import './styles.scss';

const LinkForEE = ({ children, model, isEE }): JSX.Element =>
  !model?.cta2?.value?.href || isEE ? (
    <>{children}</>
  ) : (
    <RoutableNotEditableLink href={model?.cta2?.value?.href} className="card-column__link">
      {children}
    </RoutableNotEditableLink>
  );

const IconCard: FC<ComponentConsumerProps & TIconCardProps> = ({ model, textcolor, secondarycta, cardHeadingTag, isEE, showInMobile, sitecoreContext }) => {
  return (
    <LinkForEE model={model} isEE={isEE}>
      <FieldEditFrameComponent itemId={model?.itemid} fields={[fields.icon]} sitecoreContext={sitecoreContext}>
        <Icon iconField={model?.icon} color="primary" size={iconSize.md} extraClassName="icon-card__icon" />
      </FieldEditFrameComponent>

      <div className="card-column__text-wrapper">
        <div className="card-column__text-wrapper--body">
          {model?.title && (
            <CustomText
              tag={cardHeadingTag}
              field={model?.title}
              className={`card-column__title card-column-layout__text-color-${textcolor}`}
            />
          )}
          {model?.subheading && (
            <RichText
              tag="div"
              field={model?.subheading}
              className={`card-column__description ${
                !showInMobile ? 'card-column__description--hide' : ''
              } card-column-layout__text-color-${textcolor} rich-text color-inherit-link`}
            />
          )}
        </div>
        {(model?.validcta2Exists || model?.downloadButtonLink?.value?.href) && (
          <CardColumnButtons
            cta2={model?.cta2}
            secondaryctaColor={secondarycta}
            validcta2Exists={model?.validcta2Exists}
            downloadButtonLink={model?.downloadButtonLink}
            validDownloadExists={model?.validDownloadExists}
            cta2Click={() => {
              googleHomeServicesClickEvent(model?.title?.value, model?.cta2?.value?.href, model?.cta2?.value?.title);
            }}
          />
        )}
      </div>
    </LinkForEE>
  );
};

export default IconCard;
